export default __webpack_public_path__ + "static/new-hero-fdfb5674e5b3b34224becb4e4581959b.png";